//* HOCs
import { withUIContext } from 'context'
import Tree from 'react-d3-tree';
import { useRouter } from 'next/router'


const FeedbackTree = ({ data, winWidth }) => {
    const router = useRouter()

    const handleFeedback = (id, type) => {
        if (type == 'feedback') {
            router.push(`/feedback/${id}`, undefined, { shallow: true })
        } else {
            router.push(`/debate/${id}`, undefined, { shallow: true })
        }
    }

    const renderRectSvgNode = ({ nodeDatum, toggleNode }) => {
        const onClick = () => {
            handleFeedback(nodeDatum.id, nodeDatum.__rd3t.depth == 0 ? 'debate' : 'feedback')
            toggleNode()
        }
        return (
            <g className={`${nodeDatum.type}  ${nodeDatum.id == Number(router.query.id) ? 'active' : ''}`}>
                <rect width={`${winWidth > 601 ? 30 : 23}`} height={`${winWidth > 601 ? 22 : 17}`} x="-15" rx="5" onClick={onClick} />
            </g>
        )
    };

    return (
        <div className="treeWrapper" style={{ width: '100%', height: 'auto' }}>
            <Tree
                renderCustomNodeElement={renderRectSvgNode}
                orientation={'vertical'}
                pathFunc={'step'}
                zoom={1.2}
                zoomable={false}
                nodeSize={
                    winWidth > 601
                        ?
                        { x: 55, y: 25 }
                        :
                        { x: 35, y: 35 }
                }
                data={data}
                enableLegacyTransitions={true}
                initialDepth={1}
                depthFactor={55}
            />
        </div>
    )
}

export default withUIContext(FeedbackTree, ['winWidth'])